import { useEffect, useState } from 'react';

let loaded = false;
let loading = false;
const queue: Array<() => void> = [];

function loadScript(): void {
  if (loaded || loading) return;
  loading = true;
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_PLACES_API_KEY}&libraries=places`;
  script.async = true;
  script.onload = () => {
    loaded = true;
    queue.forEach((fn) => fn());
    queue.length = 0;
  };
  document.head.appendChild(script);
}

export function useGooglePlaces(): boolean {
  const [ready, setReady] = useState(loaded);

  useEffect(() => {
    if (!process.env.GOOGLE_PLACES_API_KEY) return;
    if (loaded) {
      setReady(true);
      return;
    }
    queue.push(() => setReady(true));
    loadScript();
  }, []);

  return ready;
}
